var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2.05176C8.04153 2.05176 4.42717 5.66612 4.42717 10.1247V10.8581C4.42717 11.584 4.21228 12.2938 3.80959 12.8978L2.61312 14.6925C1.22449 16.7755 2.2846 19.6068 4.6998 20.2654C5.48689 20.4801 6.28063 20.6617 7.07898 20.8102L7.08096 20.8155C7.88199 22.9529 10.0229 24.4476 12.5 24.4476C14.9771 24.4476 17.1181 22.9529 17.9191 20.8155L17.9211 20.8102C18.7194 20.6617 19.5133 20.4801 20.3004 20.2654C22.7156 19.6068 23.7757 16.7755 22.387 14.6925L21.1906 12.8978C20.7879 12.2938 20.573 11.584 20.573 10.8581V10.1247C20.573 5.66612 16.9586 2.05176 12.5 2.05176ZM16.0171 21.1007C13.6808 21.3799 11.3192 21.3798 8.98284 21.1006C9.72342 22.1648 11.0115 22.8851 12.5 22.8851C13.9885 22.8851 15.2766 22.1648 16.0171 21.1007ZM5.98967 10.1247C5.98967 6.52907 8.90448 3.61426 12.5 3.61426C16.0957 3.61426 19.0105 6.52907 19.0105 10.1247V10.8581C19.0105 11.8926 19.3167 12.9038 19.8905 13.7646L21.0869 15.5593C21.884 16.7548 21.2756 18.3799 19.8892 18.758C15.0515 20.0774 9.94869 20.0774 5.11092 18.758C3.72463 18.3799 3.11615 16.7548 3.91321 15.5593L5.10967 13.7646C5.68347 12.9038 5.98967 11.8926 5.98967 10.8581V10.1247Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.290f911dae62badafeca8d92588264f6.svg";
export { ForwardRef as ReactComponent };